import {
	makeEmptyCell,
	makeHeaderCellForColumn,
	makePropertiesCellForColumn,
} from "./helper.js";
import ColumnTitleRenderer from "../../ColumnTitleRenderer/ColumnTitleRenderer.js";

/**
 * Visitor that output column title for an Excel file.
 */
export default class ExcelColumnTitleRenderer extends ColumnTitleRenderer {
	visitAbstractColumn(column) {
		return {
			titleCell: makeHeaderCellForColumn({
				column,
				content: this._itemTitleRenderer(column),
			}),
			propertiesCell: makeEmptyCell(),
		};
	}

	visitAbstractPeriodColumn(column) {
		const defaultResult = this.visitAbstractColumn(column);
		const columnProperties = this._columnPropertiesRenderer({ column });

		if (!columnProperties) {
			return defaultResult;
		}

		return {
			titleCell: defaultResult.titleCell,
			propertiesCell: makePropertiesCellForColumn({
				column,
				content: columnProperties,
			}),
		};
	}

	visitGroupColumn(groupColumn) {
		const children = groupColumn
			.getColumns()
			.filter((column) => column.getType() !== "SeparatorColumn")
			.flatMap((column) => {
				const titleRenderer = column.accept(this);

				return titleRenderer.titleCell
					? titleRenderer
					: titleRenderer.children;
			});

		const titleCell = groupColumn.hasTitle()
			? makeHeaderCellForColumn({
					column: groupColumn,
					content: this._itemTitleRenderer(groupColumn),
				})
			: undefined;

		return {
			titleCell,
			propertiesCell: makeEmptyCell(),
			children,
		};
	}

	_columnPropertiesRenderer({ column }) {
		return [
			this._columnBudgetRenderer({ column }),
			this._columnDimensionRenderer({ column }),
		]
			.join(" ")
			.trim();
	}

	_propertyRenderer({ property }) {
		return property;
	}

	_emptyProperty() {
		return "";
	}
}
